/**
 * Deep links into Orcanos.
 *
 * The tenant base URL already carries the account segment (`https://app.orcanos.com/orca60`),
 * which is why nothing here needs to know the account name.
 *
 * ⚠️ `Item=` takes the work-item ORIGINAL CODE (`MR_REQ`, `T_CASE`, `DMS`), never the
 * label the user picked in the dropdown ("Software Requirement") — the listing page 404s
 * on a label. And the version is the level's own `version_id`, not the panel's: a block can
 * sit in a different project/version from L1.
 */

/** A saved filter's item listing: {base}/web/{ver}/items/listing?Item={code}&FilterId={id}
 *  Returns '' when any part is missing, so callers can render nothing rather than a broken link. */
export function filterListingUrl(baseUrl, versionId, itemTypeCode, filterId) {
  if (!baseUrl || !versionId || !itemTypeCode || filterId === '' || filterId == null) return '';
  const base = String(baseUrl).replace(/\/+$/, '');
  return `${base}/web/${encodeURIComponent(versionId)}/items/listing`
       + `?Item=${encodeURIComponent(itemTypeCode)}`
       + `&FilterId=${encodeURIComponent(filterId)}`;
}
